import React, { useState, useEffect, useRef } from "react";
import ourWorksBg from "../assets/journey.webp";
import "./trainingsimple.css";
import Globe from "../assets/simple1.webp";
import Server from "../assets/simple2.webp";
import BookOpen from "../assets/simple3.webp";
import TrendingUp from "../assets/simple4.webp";

export default function TrainingSimple() {
  const cardsRef = useRef(null);
  const sectionRef = useRef(null);

  const [filledWords, setFilledWords] = useState(0);
 const [animate, setAnimate] = useState(false);
const [hasAnimated, setHasAnimated] = useState(
  sessionStorage.getItem("trainingSimpleAnimated") === "true"
);


  const paragraph = [
    "Learning made",
    "simple, accessible, and effective."
  ].join(" ").split(" ");

  const maxWords = paragraph.length;
  const lastScrollY = useRef(window.scrollY);

  /* ================= TEXT SCROLL FILL ================= */
  useEffect(() => {
    function onScroll() {
      if (!sectionRef.current) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const viewportH = window.innerHeight;
      const centerY = viewportH / 2;

      const currentScroll = window.scrollY;
      const scrollingDown = currentScroll > lastScrollY.current;
      const scrollingUp = currentScroll < lastScrollY.current;
      lastScrollY.current = currentScroll;

      const distanceFromCenter = centerY - rect.top;
      const fillWindow = viewportH * 0.35;

      let progress = distanceFromCenter / fillWindow;
      progress = Math.max(0, Math.min(1, progress));

      const targetWords = Math.floor(progress * maxWords);

      if (scrollingDown && targetWords > filledWords) {
        setFilledWords(targetWords);
      }

      if (scrollingUp && targetWords < filledWords) {
        setFilledWords(targetWords);
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, [filledWords, maxWords]);

  /* ================= CARD FLOWER EFFECT ================= */
useEffect(() => {
  if (hasAnimated) {
    setAnimate(true); // already once animation nadandhuduchu
    return;
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          setAnimate(true);
          setHasAnimated(true);
          sessionStorage.setItem("trainingSimpleAnimated", "true");
        }, 400);
      }
    },
    { threshold: 0.4 }
  );

  if (cardsRef.current) observer.observe(cardsRef.current);

  return () => observer.disconnect();
}, [hasAnimated]);


  return (
    <div className="workprocess mobile-training-workprocess">
      {/* ===== ABOUT ===== */}
      <div className="workprocess-section" ref={sectionRef}>
        <div className="container">
         {/* <p className="animated-text">
            {paragraph.map((word, index) => (
              <span
                key={index}
                className={`word ${
                  index < filledWords ? "filled" : ""
                } ${word === "simple," ? "gradient-word" : ""}`}
              >
                {word + " "}
              </span>
            ))}
          </p> */}
       <div className="workprocess-section mobile-title-full">
  <div className="container mobile-container-full">

<div className="training-heading-wrapper training-title-mobile-fix" ref={sectionRef}>
      <p className="animated-text2 training-mobile-lines">
        {paragraph.map((word, index) => (
          <span
            key={index}
            className={`word 
              ${index < filledWords ? "filled" : ""} 
              ${word === "simple," ? "gradient-word" : ""}
            `}
          >
            {word + " "}
          </span>
        ))}
      </p>
    </div>

  </div>
</div>


        </div>
      </div>
      <div className="divider-card-container">
        {/* ===== CARDS ===== */}
        <div className="workprocess-scroll-area">
          <div
            ref={cardsRef}
            className={`workprocess-cards-grid ${animate ? "cards-open" : ""}`}
          >
            <Card
  img={Globe}
  title="Certified"
  sub="Course"
  text="Job-ready skills with strong fundamentals."
/>

<Card
  img={Server}
  title="Internship"
  sub="Program"
  text="Real industry exposure with hands-on work."
/>

<Card
  img={BookOpen}
  title="Inplant"
  sub="Training"
  text="Practical learning inside real companies."
/>

<Card
  img={TrendingUp}
  title="Student"
  sub="Projects"
  text="Projects that boost skills and confidence."
/>

          </div>
        </div>
      </div>
    </div>
  );
}

/* ===== SMALL CARD COMPONENT ===== */
function Card({ img, title, sub, text }) {
  return (
    <div className="workprocess-card">
      <div className="workprocess-icon-wrapper">
        <img src={img} alt="" />
      </div>
      <h3 className="workprocess-card-title">
        {title} <br /> {sub}
      </h3>
      <p className="workprocess-card-description">{text}</p>
    </div>
  );
}
